const createApiIri = (collection: string, id: string | number) => `/api/${collection}/${id}`;

export default createApiIri;
